import omit from 'lodash/omit';

export function allIds(state, action) {
  const { containerId } = action.payload;
  return state.filter(givenId => givenId !== containerId);
}

export function byId(state, action) {
  const { containerId } = action.payload;

  const updatedByIds = omit(state, containerId);

  return { ...updatedByIds };
}
